import {
  Component,
  OnInit,
  Renderer2,
  OnDestroy,
  HostBinding
} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {AppService} from '@services/app.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {
  /* @HostBinding('class') class = 'register-box';*/

  /*public registerForm: UntypedFormGroup;*/
  public isAuthLoading = false;
  public isGoogleLoading = false;
  public isFacebookLoading = false;
  words: string[] = ["Trendy Styles", "Elegant Wear", "Chic Designs", "Modern Outfits"];
  currentText: string = "";
  wordIndex: number = 0;
  charIndex: number = 0;
  isDeleting: boolean = false;
  typingSpeed: number = 150; // Speed of typing
  deletingSpeed: number = 75; // Speed of deleting
  showPassword = false;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.registerForm.get("phoneNumber")?.valueChanges.subscribe((value) => {
      this.registerForm.get("whatsappNumber")?.setValue(value);
    });
  }

  ngOnInit() {
    this.renderer.addClass(
      document.querySelector('app-root'),
      'register-page'
    );
    this.typeEffect();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  typeEffect() {
    let word = this.words[this.wordIndex];

    if (this.isDeleting) {
      this.currentText = word.substring(0, this.charIndex--);
    } else {
      this.currentText = word.substring(0, this.charIndex++);
    }

    if (!this.isDeleting && this.charIndex === word.length) {
      setTimeout(() => (this.isDeleting = true), 1000);
    } else if (this.isDeleting && this.charIndex === 0) {
      this.isDeleting = false;
      this.wordIndex = (this.wordIndex + 1) % this.words.length;
    }

    setTimeout(() => this.typeEffect(), this.isDeleting ? this.deletingSpeed : this.typingSpeed);
  }

  registerForm = new UntypedFormGroup({
    name: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
    countryCode: new UntypedFormControl("91", []),
    phoneNumber: new UntypedFormControl("", [Validators.required, Validators.nullValidator,
      Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10),
      Validators.maxLength(10)]),
    email: new UntypedFormControl("", [Validators.required, Validators.nullValidator, Validators.email]),
    password: new UntypedFormControl("", [Validators.required, Validators.minLength(10),
      Validators.maxLength(10)]),
    userType: new UntypedFormControl("USER", []),
    whatsappNumber: new UntypedFormControl("", []),
  });

  public registerErrors = {
    email: '',
    password: '',
    name: '',
    phoneNumber: '',
  }


  // Login Validation is any Mandatory fields is empty
  loginValidation() {
    this.registerErrors.email = "";
    this.registerErrors.password = "";
    this.registerErrors.name = "";
    this.registerErrors.phoneNumber = "";
    let hasError = false;
    if (this.registerForm.get("name")?.invalid) {
      this.registerErrors.name = "Name is required";
      hasError = true;
    }
    if (this.registerForm.get('phoneNumber')?.invalid) {
      if (this.registerForm.get('phoneNumber').errors.required) {
        this.registerErrors.phoneNumber = "Phone Number is required";
      }
      if (this.registerForm.get('phoneNumber').errors.pattern) {
        this.registerErrors.phoneNumber = "Please, Enter 10 digit Valid Phone Number.";
      }
      hasError = true;
    }
    if (this.registerForm.get('email')?.invalid) {
      if (this.registerForm.get('email').errors.required) {
        this.registerErrors.email = "Email address is required";
      }
      if (this.registerForm.get('email').errors.email) {
        this.registerErrors.email = "Please enter valid email address";
      }
      hasError = true;
    }
    if (this.registerForm.get("password")?.invalid) {
      if (this.registerForm.get("password")?.hasError("required")) {
        this.registerErrors.password = "Please enter a password";
      } else if (this.registerForm.get("password")?.hasError("minlength")) {
        this.registerErrors.password = "Password must be at least 10 characters long";
      } else if (this.registerForm.get("password")?.hasError("maxlength")) {
        this.registerErrors.password = "Password cannot exceed 10 characters";
      }
      hasError = true;
    }
    if (!hasError) {
      this.saveRegisteredDetails();
    }
  }

  onSubmit() {
    this.loginValidation()
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  saveRegisteredDetails() {
    this.spinner.show();
    console.log(`user details:`, this.registerForm.value);
    this.appService.saveUserRegisteredDetails(this.registerForm.value)
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          console.log("User registered successfully", response);
          this.toastr.success("Registration successful!");
          this.router.navigate(['/login']);
        },
        error: (error) => {
          this.spinner.hide();
          console.error("Error registering user", error);
          this.toastr.error(error.error.message);
        },
      });
  }


  async registerByAuth() {
    if (this.registerForm.valid) {
      this.isAuthLoading = true;
      await this.appService.registerWithEmail(
        this.registerForm.value.email,
        this.registerForm.value.password
      );
      this.isAuthLoading = false;
    } else {
      this.toastr.error('Form is not valid!');
    }
  }

  async registerByGoogle() {
    this.isGoogleLoading = true;
    await this.appService.signInByGoogle();
    this.isGoogleLoading = false;
  }

  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'register-page'
    );
  }
}
